import { render } from "./MyAnimeList.vue?vue&type=template&id=9bcdfa8e&scoped=true"
import script from "./MyAnimeList.vue?vue&type=script&lang=js"
export * from "./MyAnimeList.vue?vue&type=script&lang=js"

import "./MyAnimeList.vue?vue&type=style&index=0&id=9bcdfa8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcdfa8e"]])

export default __exports__